// extracted by mini-css-extract-plugin
export default {"container":"subscriptionsByRule_container__cO8UD","loader":"subscriptionsByRule_loader__lj4bW","error":"subscriptionsByRule_error__p-xiv"};